export const showModalSurchargeService = () => ({
  type: "SHOW_MODAL_SURCHARGE_SERVICE",
});

export const closeModalSurchargeService = () => ({
  type: "CLOSE_MODAL_SURCHARGE_SERVICE",
});
